<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 21 20"
    fill="none"
    class="outline-none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.7072 10.98C17.7472 10.66 17.7772 10.34 17.7772 10C17.7772 9.66 17.7472 9.34 17.7072 9.02L19.8172 7.37C20.0072 7.22 20.0572 6.95 19.9372 6.73L17.9372 3.27C17.8172 3.05 17.5472 2.97 17.3272 3.05L14.8372 4.05C14.3172 3.65 13.7572 3.32 13.1472 3.07L12.7672 0.42C12.7372 0.18 12.5272 0 12.2772 0H8.27718C8.02718 0 7.81718 0.18 7.78718 0.42L7.40718 3.07C6.79718 3.32 6.23718 3.66 5.71718 4.05L3.22718 3.05C2.99718 2.96 2.73718 3.05 2.61718 3.27L0.617183 6.73C0.487183 6.95 0.547183 7.22 0.737183 7.37L2.84718 9.02C2.80718 9.34 2.77718 9.67 2.77718 10C2.77718 10.33 2.80718 10.66 2.84718 10.98L0.737183 12.63C0.547183 12.78 0.497183 13.05 0.617183 13.27L2.61718 16.73C2.73718 16.95 3.00718 17.03 3.22718 16.95L5.71718 15.95C6.23718 16.35 6.79718 16.68 7.40718 16.93L7.78718 19.58C7.81718 19.82 8.02718 20 8.27718 20H12.2772C12.5272 20 12.7372 19.82 12.7672 19.58L13.1472 16.93C13.7572 16.68 14.3172 16.34 14.8372 15.95L17.3272 16.95C17.5572 17.04 17.8172 16.95 17.9372 16.73L19.9372 13.27C20.0572 13.05 20.0072 12.78 19.8172 12.63L17.7072 10.98ZM10.2772 13.5C8.34718 13.5 6.77718 11.93 6.77718 10C6.77718 8.07 8.34718 6.5 10.2772 6.5C12.2072 6.5 13.7772 8.07 13.7772 10C13.7772 11.93 12.2072 13.5 10.2772 13.5Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'SettingIcon',
  props: {
    width: {
      type: Number,
      default: 21
    },
    height: {
      type: Number,
      default: 20
    },
    color: {
      type: String,
      default: '#73777A'
    }
  }
}
</script>
